"use client";

import { useQuery } from "@tanstack/react-query";
import {
  getBrands,
  getTopDealBrands,
} from "@/features/brands/services/brands.service";

export interface Brand {
  id: string;
  name: string;
  slug: string;
  logo_url: string | null;
  product_image: string | null;
  product_count: number;
  avg_rating: string;
  total_reviews: number;
  logo_bw_url?: string | null;
  banner_url?: string | null;
  is_top_deal?: boolean;
  top_deal_order?: number | null;
  max_discount_percentage?: number | null;
}

const BRANDS_QUERY_KEY = ["brands"] as const;
const TOP_DEAL_BRANDS_QUERY_KEY = ["brands", "top-deals"] as const;

export function useBrandsQuery() {
  const query = useQuery({
    queryKey: BRANDS_QUERY_KEY,
    queryFn: () => getBrands<Brand>(),
  });

  return {
    brands: query.data ?? [],
    loading: query.isPending,
    error: query.error,
    refetch: query.refetch,
  } as const;
}

export function useTopDealBrandsQuery() {
  const query = useQuery({
    queryKey: TOP_DEAL_BRANDS_QUERY_KEY,
    queryFn: () => getTopDealBrands<Brand>(),
  });

  return {
    brands: query.data ?? [],
    loading: query.isPending,
    error: query.error,
    refetch: query.refetch,
  } as const;
}
